import React from 'react';
import { useFelaEnhanced } from '@ackee/fela';

import * as felaRules from './PlayPauseButton.rules';

interface PlayPauseButtonProps {
    isPlaying: boolean;
    onClick: () => void;
    shouldShow: boolean;
    large: boolean;
}

export const PlayPauseButton = ({ isPlaying, onClick, shouldShow, large }: PlayPauseButtonProps) => {
    const { styles } = useFelaEnhanced(felaRules, { shouldShow, large });
    return (
        <button aria-label={isPlaying ? 'pause' : 'play'} className={styles.button} type="button" onClick={onClick} />
    );
};
